import React, { useEffect, useRef, useCallback } from 'react';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';
import DialogPopup from '../../Popup/Dialog/DialogPopupLayout';
import CollectionsList from '../CollectionList';
import Button from '../../Button';
import { BiDataHook, BiEventType } from '../../biLogger';
import { getDeviationResourceType } from '../../DeviationViews/_helpers';
import s from './MobileCollectionPopup.scss';
export var MobileCollectionPopup = function (_a) {
    var collectibleDeviation = _a.collectibleDeviation, commitCollections = _a.commitCollections, undoChanges = _a.undoChanges, requestClose = _a.requestClose, initializeDeviation = _a.initializeDeviation, selectedFolderCount = _a.selectedFolderCount, selectedFolderIds = _a.selectedFolderIds;
    var t = useTranslation().t;
    var previousDeviationId = useRef();
    var onDoneClick = useCallback(function () {
        commitCollections(collectibleDeviation, 'default');
        requestClose();
    }, [collectibleDeviation, commitCollections, requestClose]);
    var onCancelClick = useCallback(function () {
        undoChanges(collectibleDeviation.deviationId);
        requestClose();
    }, [collectibleDeviation.deviationId, requestClose, undoChanges]);
    useEffect(function () {
        if (previousDeviationId.current !== collectibleDeviation.deviationId) {
            initializeDeviation(collectibleDeviation.deviationId, get(collectibleDeviation, 'stats.favourites', 0));
        }
        previousDeviationId.current = collectibleDeviation.deviationId;
    }, [collectibleDeviation, initializeDeviation]);
    return (React.createElement(DialogPopup, { isOpen: true, title: t('collectionPanel.addToFavourites'), headerClassName: s['title'], footer: React.createElement(React.Fragment, null,
            React.createElement(Button, { view: "b2", className: s['cancel'], onClick: onCancelClick }, t('common.cancel')),
            React.createElement(Button, { view: "b1", className: s['done'], onClick: onDoneClick, biData: {
                    evid: BiEventType.ADD_TO_COLLECTION_DONE_CLICK,
                    creatorid: collectibleDeviation.author &&
                        collectibleDeviation.author.useridUuid,
                    typeid: getDeviationResourceType(collectibleDeviation),
                    itemid: collectibleDeviation.deviationId,
                    sectionname: undefined,
                    collectionid: selectedFolderCount > 1 ? undefined : selectedFolderIds[0],
                    num_collections: selectedFolderCount,
                } }, t('common.done'))), onClose: onCancelClick },
        React.createElement("div", { className: s['content'], "data-hook": BiDataHook.DEVIATION_ADD_TO_FAVES_POPUP },
            React.createElement("div", { className: s['subtitle'] }, t('collectionPanel.chooseAnyCollection')),
            React.createElement(CollectionsList, { collectibleDeviation: collectibleDeviation }))));
};
export default MobileCollectionPopup;
//# sourceMappingURL=MobileCollectionPopup.js.map